import { defineStore } from 'pinia'
import { useRootStore } from '@/stores/root'
import http from '@/services/http'

export const useDocumentsStore = defineStore('documents', {
  actions: {
  async documentExpirationNotes({ documentId, lineCode, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/expirationnotes`,
        // Il backend (DocumentController::documentExpirationNotes, pgm AS400 EJSC10)
        // legge `$_GET["linecode"]` MINUSCOLO per valorizzare SCARIG. Inviando
        // `lineCode` (camelCase) PHP non lo trova → SCARIG vuoto → nota mai restituita.
        params: { linecode: lineCode },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async documentDetail({ documentId, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/detail`,
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async documentRowOpened({ documentId, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/rowOpened`,
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async documentSummary({ documentId, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/summary`,
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDocumentsList({ forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/list',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDocumentTypes({ forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/documentType',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async documentConvert({
    documentCode,
    documentId,
    data,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: `/documents/${documentId}/documentconvert?coddoc=${documentCode}`,
        data,
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getSpecificDocumentsByDate({ documentType, dateFilter,codfil, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getDocumentDate',
        params: {
          tipdoc: documentType,
          datdoc: dateFilter,
          codfil,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getBackorderDocuments({ documentType,codfil, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getBackorder',
        params: {
          tipdoc: documentType,
          codfil
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getBackorderDocumentsRows({ type,codfil, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/customers/customersBackorderRows',
        params: {
          tipdat: type,
          codfil
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getAutomaticOrderPayment({ protocol, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getAutomaticOrderPayment',
        params: {
          numpro: protocol,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDocumentsRecap({
    date,
    mode,
    typeDoc,
    codfil,
    forceRefresh,
  }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getOrderSummary',
        params: {
          sltdoc: typeDoc,
          tiptot: mode,
          codfil,
          datinz: date,
          datfin: date,

        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDocumentsRecapMode({ forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/tablelist/tipriep',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getRetiredDocuments({ codfil,forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getListRetiredBill',
        params: {
          codfil
        }
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getCausalReasons({ forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getCancelOffer',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDocumentAnalysis({ documentId, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getOrderAnalysis',
        params: {
          numpro: documentId,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async offerCancellation({ documentId, codeReason, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'post',
        path: `/documents/${documentId}/documentCancel`,
        data: {
          motoff: codeReason,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async documentDetailVisual({ documentId, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/detailVisual`,
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async documentCodeList({ documentType,codcli, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentType}/getDocumentsCodelist`,
        params:{codcli}
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDocumentPDF(documentId, forceRefresh = true) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getPdf',
        params: {
          numpro: documentId,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getEmailList({ printCode, loader = true, forceRefresh }) {
    if (loader) useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/getDestinationSendDocument',
        params: {
          anatip: '1',
          customerId: useRootStore().lastCustomer.anacod,
          codsta: printCode,
        },
      }, forceRefresh);
      if (loader) useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      if (loader) useRootStore().setIsLoading(false);
      return false;
    }
  },
  async sendDocumentEmail({ protocol, email, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/sendDocumentEmail',
        params: {
          numpro: protocol,
          iemail: email || '',
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getDocumentMargins({ numpro, tipcos, forceRefresh }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/documents/marginsOffers',
        params: {
          numpro,
          tipcos,
        },
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  async getTransportMode(forceRefresh = false) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: '/tablelist/transportMode',
      }, forceRefresh);
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      useRootStore().setIsLoading(false);
      return false;
    }
  },
async documentsCommission(
    {
      documentId,
      articleCode,
      quantity,
      discount1,
      discount2,
      discount3,
      discount4,
      price,
      rowType
    }) {
    useRootStore().setIsLoading(true);
    try {
    //       console.log('documentsCommission',{
    //   documentId,
    //   articleCode,
    //   quantity,
    //   discount1,
    //   discount2,
    //   discount3,
    //   discount4,
    //   price,
    //   rowType
    // });
      const response = await http.request({
        method: 'post',
        path: `/documents/${documentId}/commission`,
        data: Object.assign(
          {
            codart: articleCode || '',
            qta: quantity,
            scont1: discount1 || 0,
            scont2: discount2 || 0,
            scont3: discount3 || 0,
            scont4: discount4 || 0,
            prezzo: price || 0,
            tipmov:rowType
          }
        ),
      }, true);
  
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      // console.error('documentsCommission',err);
      useRootStore().setIsLoading(false);
      return false;
    }
  },
async getDocumentMedia(
    {
      documentId
    }) {
    useRootStore().setIsLoading(true);
    try {
      const response = await http.request({
        method: 'get',
        path: `/documents/${documentId}/media`,
      }, true);
  
      useRootStore().setIsLoading(false);
      return response;
    } catch (err) {
      // console.error('documentsCommission',err);
      useRootStore().setIsLoading(false);
      return false;
    }
  },
  },
})
